import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type ListCompanyStatusResponse =
  operations['listSupplierIntegrationCompanyStatus']['responses'][200]['content']['application/json'];

export type CompanyStatus = ListCompanyStatusResponse['data'][number];

const useCompanyStatus = () => {
  return useQuery({
    // This is intentionally not useSuspenseQuery — the Plaid exchange flow invalidates this query
    // while its own success modal is still open, and a suspense query would re-suspend the whole
    // tree (unmounting the modal mid-flow) instead of just updating in place.
    queryKey: ['companyStatus'],
    queryFn: () => apiClient.get('api/supplier-experience/companies/status').json<ListCompanyStatusResponse>(),
    select: (response) => response.data,
    placeholderData: keepPreviousData,
  });
};

export default useCompanyStatus;
